import styled from 'styled-components';

export const TableTreeScope = styled.div`
  margin-top: 8px;

  div[role="gridcell"] {
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
`;
